import React from 'react';
import { Box, Typography, Button, Grid, Container, Chip } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import heroImg from '../../../images/re_crm_hero.png';

const Hero = () => (
  <Box sx={{ minHeight: '92vh', display: 'flex', alignItems: 'stretch', overflow: 'hidden', position: 'relative' }}>
    {/* LEFT PANEL - dark */}
    <Box sx={{
      width: { xs: '100%', md: '52%' },
      background: 'linear-gradient(160deg, #020817 0%, #0c1a3d 50%, #0f2460 100%)',
      display: 'flex', alignItems: 'center',
      px: { xs: 4, md: 8 }, py: { xs: 10, md: 6 },
      position: 'relative', zIndex: 2,
      clipPath: { xs: 'none', md: 'polygon(0 0, 95% 0, 100% 100%, 0 100%)' },
    }}>
      {/* Teal glow */}
      <Box sx={{ position: 'absolute', width: 300, height: 300, borderRadius: '50%', background: 'radial-gradient(circle, rgba(6,182,212,0.15) 0%, transparent 65%)', bottom: 50, left: 50, pointerEvents: 'none' }} />

      <Box sx={{ maxWidth: 500, position: 'relative', zIndex: 1 }}>
        <Chip label="Real Estate CRM" sx={{ bgcolor: 'rgba(6,182,212,0.15)', color: '#22d3ee', border: '1px solid rgba(6,182,212,0.4)', fontWeight: 700, mb: 3, fontFamily: "'Montserrat', sans-serif", letterSpacing: 1 }} />

        <Typography variant="h1" sx={{ color: '#fff', fontWeight: 900, fontSize: { xs: '2rem', md: '3rem' }, lineHeight: 1.15, mb: 3, fontFamily: "'Montserrat', sans-serif" }}>
          Close More{' '}
          <Box component="span" sx={{ background: 'linear-gradient(90deg, #22d3ee, #06b6d4)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
            Property Deals
          </Box>
          {' '}with Intelligent CRM
        </Typography>

        <Typography sx={{ color: 'rgba(255,255,255,0.65)', fontSize: 16, mb: 4, lineHeight: 1.85, fontFamily: "'Montserrat', sans-serif" }}>
          Purpose-built for builders, developers & brokers. Centralize leads from all portals, automate follow-ups and get complete visibility into your sales pipeline — all in one place.
        </Typography>

        {/* Highlight stats */}
        <Grid container spacing={2} sx={{ mb: 4 }}>
          {[['2x','Deal Closure Speed'],['48hr','Lead Response Time'],['₹0','Integration Cost']].map(([v, l]) => (
            <Grid item xs={4} key={l}>
              <Box sx={{ borderLeft: '3px solid #22d3ee', pl: 1.5 }}>
                <Typography sx={{ color: '#22d3ee', fontWeight: 900, fontSize: '1.5rem', fontFamily: "'Montserrat', sans-serif", lineHeight: 1 }}>{v}</Typography>
                <Typography sx={{ color: 'rgba(255,255,255,0.55)', fontSize: 11, fontFamily: "'Montserrat', sans-serif", mt: 0.3 }}>{l}</Typography>
              </Box>
            </Grid>
          ))}
        </Grid>

        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          <Button variant="contained" endIcon={<ArrowForwardIcon />} size="large"
            sx={{ bgcolor: '#0891b2', px: 4, py: 1.6, borderRadius: '12px', fontFamily: "'Montserrat', sans-serif", fontWeight: 800, fontSize: 15, boxShadow: '0 8px 32px rgba(8,145,178,0.5)', '&:hover': { bgcolor: '#0e7490', transform: 'translateY(-2px)' } }}>
            Book Free Demo
          </Button>
          <Button variant="outlined" size="large"
            sx={{ borderColor: 'rgba(255,255,255,0.3)', color: '#fff', px: 4, py: 1.6, borderRadius: '12px', fontFamily: "'Montserrat', sans-serif", '&:hover': { borderColor: '#22d3ee', bgcolor: 'rgba(6,182,212,0.05)' } }}>
            View Brochure
          </Button>
        </Box>
      </Box>
    </Box>

    {/* RIGHT PANEL - image */}
    <Box sx={{
      display: { xs: 'none', md: 'flex' },
      width: '55%',
      position: 'absolute', right: 0, top: 0, bottom: 0,
      alignItems: 'center',
      background: 'linear-gradient(160deg, #0c1a3d 0%, #0f2a5e 40%, #0f3670 100%)',
      px: 6,
    }}>
      <Box sx={{
        width: '100%', borderRadius: '20px', overflow: 'hidden',
        boxShadow: '0 40px 100px rgba(0,0,0,0.6), 0 0 0 1px rgba(6,182,212,0.3)',
        transform: 'perspective(1200px) rotateY(-3deg)',
        transition: 'transform 0.4s',
        '&:hover': { transform: 'perspective(1200px) rotateY(0deg)' },
      }}>
        <img src={heroImg} alt="Real Estate CRM" style={{ width: '100%', display: 'block' }} />
      </Box>
    </Box>
  </Box>
);

export default Hero;
